export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ServicioSocialDescargasPage.vue?vue&type=template&id=08efddfa&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/ServicioSocialDescargasPage.vue?vue&type=template&id=08efddfa&scoped=true&
// module id = 642
// module chunks = 16